<div>
    <div style="display: flex; padding: 20px;">
        <img src="assets/images/logos/clu-dark-logo.svg" alt="logo" style="width: 130px; margin: auto;">
    </div>
    <div style="font-weight: 600;font-size: 28px;margin-bottom: 10px;">Accès non autorisé</div>
    <div style="font-weight: 600;">Le contenu auquel vous essayer d'accéder ne vous est pas autorisé.</div>
    <div style="font-weight: 600;margin-bottom: 20px;">Veuillez contacter un administrateur.</div>
    <div class="d-flex align-items-center justify-content-center p-b-24 m-t-16" *ngIf="!!authSessionDto">
        <img src="assets/images/profile/ninja-bo.png" class="rounded-circle" height="45px" />
        <div class="m-l-16">
          <h6 class="f-s-14 f-w-600 m-0">{{ authSessionDto!.USERNAME }}</h6>
          <span class="f-s-14 d-block m-b-4">Utilisateur</span>
        </div>
    </div>
    <div style="display: flex; flex-direction: column; justify-content: center; gap: 10px">
        <button mat-raised-button (click)="doLogout()" style="height: 50px; display: flex; flex-direction: row; justify-content: center; align-items: center;">
            <i-tabler name="logout" style="font-size: 10px"></i-tabler>
            Retourner à la page de connexion
        </button>
    </div>
</div>